import React, { ReactElement } from 'react';
import Box from '@mui/material/Box';

export const Post = (): ReactElement => {
  return (
    <Box>hi</Box>
  );
}
